<script setup>
import { useStore } from '~/store'
import { useOrderStore } from '~/store/order'
import { objectOmit } from '@vueuse/core'
import { useSpotStore } from '~/store/spot'

const props = defineProps({
  selects: {
    type: Array,
    default: () => [],
  },
})

const emits = defineEmits(['search'])

const { t } = useI18n()
const store = useStore()
const order = useOrderStore()
const spot = useSpotStore()
const route = useRoute()
const baseList = computed(() => store.baseCurrencyList.map(i => ({
  label: i,
  key: i,
})))
const quoteList = computed(() => store.quoteCurrencyList.map(i => ({
  label: i,
  key: i,
})))
const currencyIdList = computed(() => store.spotCurrencies.map(i => ({
  label: i.name,
  key: i.id,
})))
const ordTypeList = computed(() => [
  {
    label: t('限价'),
    key: 'LIMIT',
  },
  {
    label: t('市价'),
    key: 'MARKET',
  },
])
const sidesList = computed(() => [
  {
    label: t('买入'),
    key: 'BUY',
  },
  {
    label: t('卖出'),
    key: 'SELL',
  },
])

function search() {
  const params = props.selects.reduce((acc, next) => {
    if (order.params[next]) {
      acc[next] = order.params[next]
    }
    return acc
  }, {})
  if (order.params.dateRange) {
    params.startTime = order.params.dateRange[0]
    params.endTime = order.params.dateRange[1]
  }
  emits('search', objectOmit(params, ['dateRange']))
}

watch(() => order.params, search, { deep: true })
</script>

<template>
  <div class="flex items-end gap-x-4">
    <CommonTSearchSelect v-if="selects.includes('baseCurrency')" v-model="order.params.baseCurrency" :all-text="$t('全部币种')" class="w-[164px]" :list="baseList" :label="$t('币种')" />
    <template v-if="selects.includes('quoteCurrency')">
      <div class="pb-1.5 text-textTertiary">
        /
      </div>
      <CommonTSearchSelect v-model="order.params.quoteCurrency" hide-search :all-text="$t('报价币种')" class="w-[164px]" :list="quoteList" :label="$t('币种')" />
    </template>
    <CommonTSearchSelect v-if="selects.includes('currencyId')" v-model="order.params.currencyId" hide-search :all-text="$t('全部')" class="w-[164px]" :list="currencyIdList" :label="$t('币种')" />
    <CommonTSearchSelect v-if="selects.includes('ordType')" v-model="order.params.ordType" hide-search :all-text="$t('全部')" class="w-[164px]" :list="ordTypeList" :label="$t('订单类型')" />
    <CommonTSearchSelect v-if="selects.includes('side')" v-model="order.params.side" hide-search :all-text="$t('全部')" class="w-[164px]" :list="sidesList" :label="$t('方向')" />
    <div class="">
      <div class="mb-2 text-xs text-textTertiary">
        {{ $t('日期') }}
      </div>
      <n-date-picker v-model:value="order.params.dateRange" :start-placeholder="$t('开始时间')" :end-placeholder="$t('结束时间')" size="small" type="daterange" clearable>
        <template #clear>
          &nbsp;
        </template>
        <template #confirm="{ onConfirm }">
          <div class="pb-2">
            <CommonXButton class="!h-8" @click="onConfirm">
              {{ $t('确认') }}
            </CommonXButton>
          </div>
        </template>
      </n-date-picker>
    </div>
    <CommonTSearchSelect v-if="selects.includes('transferType')" v-model="order.params.transferType" hide-search :all-text="$t('全部类型')" class="w-[164px]" :list="spot.transferTypeList" :label="$t('类型')" />
    <CommonXButton v-if="selects.includes('cancelAll')" type="tertiary" class="!h-8 shrink-0" @click="spot.modal.cancelAll = true">
      {{ $t('一键撤单') }}
    </CommonXButton>
    <OrdersModalSpotCancelAll width="400px" />
  </div>
</template>
